import { render } from "./SVGNewSeparator.vue?vue&type=template&id=7aac0fae"
import script from "./SVGNewSeparator.vue?vue&type=script&lang=js"
export * from "./SVGNewSeparator.vue?vue&type=script&lang=js"

import exportComponent from "/home/devops/tool_cases/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__